import * as R from 'ramda'

export const START_TRACKING_REQUEST = 'api-client/http/START_TRACKING_REQUEST'
export const STOP_TRACKING_REQUEST = 'api-client/http/STOP_TRACKING_REQUEST'

export function startTrackingRequest(request) {
  return {
    type: START_TRACKING_REQUEST,
    payload: request,
  }
}

export function stopTrackingRequest(request) {
  return {
    type: STOP_TRACKING_REQUEST,
    payload: request,
  }
}

const initialState = { requests: [] }

export function reducer(state = initialState, action) {
  switch (action.type) {
    case START_TRACKING_REQUEST: {
      return R.assoc(
        'requests',
        R.uniq(R.append(action.payload, state.requests)),
        state
      )
    }
    case STOP_TRACKING_REQUEST: {
      return R.assoc(
        'requests',
        R.reject(R.equals(action.payload), state.requests),
        state
      )
    }
    default:
      return state
  }
}

export function getPendingRequests(state) {
  return R.prop('requests', state)
}
